const PROD_APP_URL = "https://www.ratafit.com";

const LOCAL_HOSTNAMES = new Set([
  "localhost",
  "127.0.0.1",
  "::1",
  "10.0.2.2",
]);

function isLocalOrigin(origin) {
  try {
    const { hostname } = new URL(origin);
    return LOCAL_HOSTNAMES.has(hostname);
  } catch (_) {
    return false;
  }
}

export function getPublicAppOrigin() {
  const configuredBase = (process.env.REACT_APP_SHARE_BASE_URL || "").trim();
  if (configuredBase) {
    return configuredBase.replace(/\/+$/, "");
  }

  if (typeof window === "undefined") {
    return PROD_APP_URL;
  }

  const currentOrigin = window.location.origin;
  if (isLocalOrigin(currentOrigin)) {
    return PROD_APP_URL;
  }

  return currentOrigin;
}

export function buildPublicAppUrl(path = "") {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getPublicAppOrigin()}${normalizedPath}`;
}
